import { useEffect, useState } from "react";
import { createTrololoPlayer, createWiiShopPlayer } from "@/lib/wii-shop-music";

// Elad's button plays the Trololo song instead of the Wii Shop theme.
const TROLOLO_NAME = "elad";

function isTrololoUser(user?: { name?: string | null; username?: string | null } | null): boolean {
  if (!user) return false;
  const firstName = user.name?.trim().split(/\s+/)[0]?.toLowerCase();
  const username = user.username?.trim().toLowerCase();
  return firstName === TROLOLO_NAME || username === TROLOLO_NAME;
}

export function useWiiShopMusic(user?: { name?: string | null; username?: string | null } | null) {
  const trololo = isTrololoUser(user);
  // Always starts off on mount: we never auto-resume from a persisted flag, so a
  // page reload can't turn the user's next click anywhere into surprise playback.
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    // Build a fresh single-use player for the current variant on every run, so
    // toggling on (or a logout/login that flips the variant) starts the right
    // track. The player releases its AudioContext on stop().
    const player = trololo ? createTrololoPlayer() : createWiiShopPlayer();
    void player.start();
    return () => player.stop();
  }, [enabled, trololo]);

  const toggle = () => setEnabled((previous) => !previous);

  return { enabled, toggle };
}
